<template>
  <b-modal modal-class="post-login-popup" v-model="pShow" :title="pTitle">
    <div v-html="pText"></div>
    <template slot="modal-footer">
      <form @submit.prevent="send()">
        <div v-for="(condition, key) in conditions" class="mb-3 condition-line">
          <label class="conditions-checkbox">
            <input type="checkbox" v-model="conditionModel[key]">
          </label>
          <div class="d-inline-block conditions-text" v-bind:class="{ 'text-danger': showErrors && conditionValid[key] === false }" >
            <span class="conditions-label">{{condition.label}}</span>
            <span v-if="condition.required === undefined || condition.required === true" class="text-danger">*</span>
          </div>
          <div v-if="showErrors && conditionValid[key] === false" class="text-danger conditions-error">
            {{t('fieldIsRequired')}}
          </div>
        </div>
        <div class="mb-3 condition-line submit-line">
          <button type="submit" class="btn btn-success">{{t('Confirm')}}</button>
          <button type="button" class="btn btn-link" @click="pShow = false">{{t('Remind me later')}}</button>
        </div>
      </form>
    </template>
  </b-modal>
</template>

<script>
    export default {
        name: 'PostLoginPupup',
        props: {
            title: {
                type: String,
                required: true
            },
            text: {
                type: String,
                required: true
            },
            conditions: {
                type: Array,
                required: true,
            }
        },
        mounted() {
            this.$store.dispatch('account/showConditionsPopup').then((data) => {
                this.pShow = data.show;
            });
        },
        methods: {
            send() {
                let valid = this.validate();
                if(valid) {
                    let formData = {};
                    this.conditions.forEach((item, key) => {
                        let condModelKey = item.model;
                        formData[condModelKey] = this.conditionModel[key] ? 1 : 0;
                    })
                    this.$store.dispatch('account/acceptConditions',formData).then(() => {
                        this.pShow = false;
                    });
                }

            },
            validate() {
                this.showErrors = false;
                this.conditions.forEach((item, key) => {
                    const isRequired = item.required === undefined || item.required === true;
                    if (isRequired && this.conditionModel[key] === false) {
                        this.conditionValid[key] = false;
                        this.showErrors = true;
                    }
                    else {
                        this.conditionValid[key] = true;
                    }
                });
                return !this.showErrors;
            }
        },

        created() {
            this.conditions.forEach((item, key) => {
                this.conditionModel[key] = item.default === undefined ? false : item.default
                this.conditionValid[key] = true
            })
        },
        data() {
            return {
                showErrors: false,
                conditionModel: {},
                conditionValid: [],
                pTitle: this.title,
                pText: this.text,
                pShow: false
            }
        }
    }
</script>

<style lang="scss">
  .post-login-popup {
    .modal-body {
      height: 25rem;
      overflow-y: scroll;
    }

    .modal-footer {
      border-top: 1px solid lightgray;
    }

    .conditions-text {
      float: left;
      font-size: 14px;
      width: 90%;
    }

    .conditions-checkbox {
      margin-right: 10px;
      float: left;
    }

    .condition-line {
      width: 100%;
      float: left;
      margin-bottom: 0.3rem !important;
      .submit-line {
        float:right;
        width: auto;
      }
    }

    .conditions-error {
      float: left;
      margin-left: 22px;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/PostLoginPopup.vue